export const charsInSingleSms = 160 // Characters for a single sms
export const charsInMultipleSms = 153 // Characters per sms for multiple sms's
